import React from 'react';
import { Link } from 'react-router-dom';
import './Articles.css';

function PaperNotes() {
  // Array of article objects with titles, descriptions, and links
  const articles = [
    {
      id: 1,
      title: 'RESA: Transparent Reasoning Models via SAEs',
      description: 'Using SAEs to transfer reasoning capabilites from postrained models to base models',
      link: '/paper-notes/RESA'
    },
    {
      id: 2,
      title: 'Stochastic Parameter Decomposition',
      description: 'Training rank-one subarrays with an importance function to decompose linear layers',
      link: '/paper-notes/SPD'
    }
  ];

  return (
    <div className="articles-container">
      <h1 className="articles-title">Paper Notes</h1>
      <p className="articles-intro">This is a collection of my thoughts on various papers, mostly related to Mechanistic Interpretability. Will mostly be focused on the methods proposed in each paper, and on follow up questions that I find useful/interesting. If you want to read about the results, then read the damn paper. Please. Please read the papers. </p>
      <div className="article-grid">
        {articles.map(article => (
          <div key={article.id} className="article-card">
            <h2 className="article-title">
              <Link to={article.link}>{article.title}</Link>
            </h2>
            <p className="article-description">{article.description}</p>
            <Link to={article.link} className="read-more">Read More</Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PaperNotes;
